import { styled } from '@mui/material/styles';
// TODO: this component is probably not used because of Select Menu not working properly with wrapper elements.
const MenuItemsBlock = styled('div', { shouldForwardProp: (prop) => prop !== 'divider' && prop !== 'noPaddingTop' })(({ theme, divider, noPaddingTop }) => ({
    paddingTop: noPaddingTop ? '0' : '.25rem',
    paddingBottom: '.25rem',
    borderTop: divider ? `1px solid ${theme.palette.zinc[200]}` : 'none',
}));
export { MenuItemsBlock };
